/** @format */
'use client';
import ConfigStoreProvider from '@/providers/ConfigStoreProvider';
import { ConfigStore } from '@/stores/config-store';
import faIcons from '@common/model/fontawesome/faIcons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';

import { SessionProvider } from 'next-auth/react';
import { StoreApi } from 'zustand/vanilla';

interface ProvidersProps {
  children: any;
}

const queryClient = new QueryClient();

let configStore: StoreApi<ConfigStore> | null = null;

/**
 * Call this once from your ConfigStoreProvider on the client.
 * It allows the interceptor to read the latest company id.
 */
export function bindConfigStore(store: StoreApi<ConfigStore>) {
  configStore = store;
}

export const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const companyId = configStore?.getState().company;
  const impersonatedRole = configStore?.getState().impersonatedRole;

  if (companyId != null) {
    config.headers = config.headers ?? {};
    config.headers['x-company-id'] = String(companyId);
  } else if (config.headers && 'x-company-id' in config.headers) {
    // optional: ensure it’s not sent when company is cleared
    delete (config.headers as Record<string, unknown>)['x-company-id'];
  }

  if (impersonatedRole) {
    config.headers = config.headers ?? {};
    config.headers['x-impersonated-role'] = impersonatedRole;
  } else if (config.headers && 'x-impersonated-role' in config.headers) {
    delete (config.headers as Record<string, unknown>)['x-impersonated-role'];
  }

  return config;
});

function Providers(props: ProvidersProps) {
  // @ts-ignore
  library.add(...faIcons);

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        {/*<DeveloperTools queryTools>*/}
        <ConfigStoreProvider>
          <div>{props.children}</div>
        </ConfigStoreProvider>
        {/*</DeveloperTools>*/}
      </QueryClientProvider>
    </SessionProvider>
  );
}

export default Providers;
